module.exports = __webpack_public_path__ + "static/img/1.65ecb3b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/zh/1.png
// module id = IOjG
// module chunks = 0